<template>
    <v-container fluid class="footer02" :class="open ? 'openned' : ''">
        <div class="footer02-header" @click="open = !open">
            <i class="mdi mdi-lock-open"></i><h3>{{ $t('messages.account.modifyPass') }}</h3> <i class="mdi mdi-chevron-right" :class="open ? 'openned' : ''"></i>
        </div>
        <div class="footer02-content">
            <v-row no-gutters>
                <v-col cols="12">
                    <v-text-field 
                        v-model="password.oldPassword"
                        :type="'password'"
                        :label="old_password_label"
                        hide-details
                    ></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-text-field 
                        v-model="password.newPassword"
                        :type="'password'"
                        :label="new_password_label"
                        :hint="password_rule"
                    ></v-text-field>
                </v-col>
                <v-col cols="6" class="error-send">
                    <p v-show='errorText'>{{ $t('messages.account.error') }}</p>
                    <p v-show='errorServer'>{{ $t('messages.account.errorServer') }}</p>
                </v-col>
                <v-col cols="6" class="submit">
                    <v-btn rounded depressed color="primary" @click="changePassword">{{ $t('messages.account.submit') }}</v-btn>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>
<script>
export default {
    data() {
        return {
            open:false,
            password: {
                email: '',
                oldPassword:'',
                newPassword:'',
            },
            errorText:false,
            errorServer: false
        }
    },
    computed: {
        new_password_label: function(){
            return this.$t('messages.account.newPass')
        },
        old_password_label: function(){
            return this.$t('messages.account.oldPass')
        },
        password_rule : function(){
            return this.$t('messages.account.rule')
        }
    },
    methods: {
        changePassword(){
            if(this.password.oldPassword.length < 3 || this.password.newPassword =="" ){
                this.errorText = true
            } else {
                this.password.email = this.$store.state.user.email;
                this.$store.dispatch('changePassword', this.password).then((result) => {
                    console.log(result);
                    if(result.data.success){
                        this.$store.dispatch('getDisconnected', {}).then(()=> {
                            this.$router.push({ name: 'Login' })
                        })
                    } else {
                        this.errorServer = true;
                    }
                })
            }
        }
    },
}
</script>
<style lang="scss">
    .footer02 {
        padding:0;
        //height:10vh;
        position:fixed;
        top:90vh;
        background-color: white;
        border-top:2px solid #eb566b;
        transition: top 0.5s ease ;
        .footer02-header {
            height:10vh;
            display:flex;
            align-items:center;
            justify-content: center;
            color: #eb566b;
            h3 {
                font-size:1.2em;
            }
            .mdi-lock-open {
                font-size:1.4em;
                margin-right:15px;
            }
            .mdi-chevron-right {
                font-size: 2em;
                margin-left: 10px;
                transition: transform 0.5s ease ;
                &.openned {
                    transform: rotate(90deg);
                }
            }
        }
        .footer02-content {
            height:25vh;
            padding:0 20px;
            .submit {
                text-align:right;
                padding:10px 0;
            }
            .error-send {
                p {
                    color:red;
                }
            }
        }
        &.openned {
            top: 65vh;
        }
    }
</style>